import { PERMISION } from "security"
import type { MenuType } from "../types"

export const cardsMenu = {
  menu: [
    {
      label: "REGISTER",
      link: "/cards/register/all",
      permission: PERMISION.CARDS.REGISTER.PERMISION
    },
    {
      label: "TRANSACTION",
      link: "#",
      permission: PERMISION.CARDS.TRANSACTION.PERMISION,
      children: [
        { label: "CREATE NEW EMPLOYEE", link: "/cards/transaction/create-new-employee", permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_EMPLOYEE.PERMISION },
        { label: "CREATE NEW CUSTOMER", link: "/cards/transaction/create-new-customer", permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_CUSTOMER.PERMISION },
        { label: "CREATE NEW VENDOR", link: "/cards/transaction/create-new-vendor", permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_VENDOR.PERMISION },
        { label: "CREATE NEW INVESTOR", link: "/cards/transaction/create-new-investor", permission: PERMISION.CARDS.TRANSACTION.CREATE_NEW_INVESTOR.PERMISION },
        { label: "CREATE SHIFT SCHEDULE", link: "/cards/transaction/create-shift-schedule/create", permission: PERMISION.CARDS.TRANSACTION.CREATE_SHIFT_SCHEDULE.PERMISION },
        { label: "APPROVAL SCHEDULE", link: "/cards/transaction/approval-shift-schedule", permission: PERMISION.CARDS.TRANSACTION.APPROVAL_SCHEDULE.PERMISION },
      ]
    },
    {
      label: "REPORT",
      link: "#",
      permission: PERMISION.CARDS.REPORT.PERMISION,
      children: [
        { label: "CARD LIST SUMMARY", link: "/cards/report/card-list-summary", permission: PERMISION.CARDS.REPORT.CARD_LIST_SUMMARY.PERMISION },
        { label: "CARD LIST DETAIL", link: "/cards/report/card-list-detail", permission: PERMISION.CARDS.REPORT.CARD_LIST_DETAIL.PERMISION },
        { label: "CARD TRANSACTION", link: "/cards/report/card-transaction", permission: PERMISION.CARDS.REPORT.CARD_TRANSACTION.PERMISION },
        { label: "OVERDUE CONTACT", link: "/cards/report/overdue-contact", permission: PERMISION.CARDS.REPORT.OVERDUE_CONTACT.PERMISION },
        { label: "DASHBOARD", link: "/cards/report/dashboard", permission: PERMISION.CARDS.REPORT.DASHBOARD.PERMISION },
      ]
    },
    {
      label: "JOURNAL",
      link: "/cards/journal",
      permission: PERMISION.CARDS.JOURNAL.PERMISION
    },
    {
      label: "FIND",
      link: "/cards/find",
      permission: PERMISION.CARDS.FIND.PERMISION
    }
  ] as MenuType[],
}